import { DEFAULTS } from '../video-component.js';
import { getModalStyles, BUTTON_TYPES, decorateComponentWithProps, INSERT_PLUGIN_BUTTONS, TOOLBARS, getBottomToolbarModalStyles } from 'wix-rich-content-editor-common';
import VideoModal from './videoModal.js';
import { ExtendedSelectionModalCustomStyle, SelectionModalCustomStyle } from './selectionModalCustomStyles.js';
import { videoButtonsTypes } from '../types.js';
import { MOBILE_FULL_SCREEN_CUSTOM_STYLE, DesktopOverlayModalStyles, DesktopFlyOutModalStyles } from 'wix-rich-content-ui-components';
import { videoModalContentStyles, embedModalContentStyles } from '../constants.js';
import InsertPluginIcon from '../icons/VideoInsertPluginIcon.js';
import InsertPluginIcon$1 from '../icons/SoundCloudInsertPluginIcon.js';
import YoutubeIcon from '../icons/YoutubeIcon.js';
import 'react';
import 'prop-types';
import 'classnames';
import 'react-dom';
import 'wix-rich-content-common';
import '../video-viewer.js';
import '../reactPlayerWrapper.js';
import 'react-player';
import 'wix-rich-content-common/dist/statics/schemas/plugin-video.schema.json';
import 'lodash';
import '../get-video-source.js';
import '../IframePlayer.js';
import '../video-viewer-200c0e68.js';
import '../style-inject.es-746bb8ed.js';
import '../default-video-styles-ee165d52.js';
import './videoSelectionInputModal.js';
import 'wix-rich-content-plugin-commons';
import './videoPluginService.js';
import './mediaURLInputModal.js';
import './NewVideoModal.js';
import './NewVideoInsertModal.js';
import './videoUploadModal.js';
import './NewMediaUrlInputModal.js';
import 'ricos-context';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const createInsertButtons = ({
  t,
  settings,
  isMobile,
  disableDownload,
  experiments = {}
}) => {
  var _a;
  const componentData = disableDownload !== void 0 ? __spreadProps(__spreadValues({}, DEFAULTS), { disableDownload }) : DEFAULTS;
  const { newVideoVerticalAndSocialModals } = experiments;
  const useNewModal = newVideoVerticalAndSocialModals == null ? void 0 : newVideoVerticalAndSocialModals.enabled;
  const {
    exposeButtons = [videoButtonsTypes.video],
    toolbar,
    enableCustomUploadOnMobile,
    handleFileSelection,
    handleFileUpload
  } = settings || {};
  const icon = ((_a = toolbar == null ? void 0 : toolbar.icons) == null ? void 0 : _a.InsertPluginButtonIcon) || InsertPluginIcon;
  const videoModalCustomStyles = isMobile ? MOBILE_FULL_SCREEN_CUSTOM_STYLE : __spreadProps(__spreadValues({}, DesktopFlyOutModalStyles), { content: videoModalContentStyles });
  const embedModalCustomStyles = isMobile ? MOBILE_FULL_SCREEN_CUSTOM_STYLE : __spreadProps(__spreadValues({}, DesktopFlyOutModalStyles), { content: embedModalContentStyles });
  const defaultCustomStyles = (!isMobile || enableCustomUploadOnMobile) && (handleFileSelection || handleFileUpload) ? ExtendedSelectionModalCustomStyle : SelectionModalCustomStyle;
  const customStyles = useNewModal ? videoModalCustomStyles : defaultCustomStyles;
  const modalsStyle = getModalStyles({
    customStyles,
    fullScreen: !!useNewModal,
    isMobile
  });
  const newModalStyles = isMobile ? modalsStyle : void 0;
  const modalStyles = useNewModal ? newModalStyles : modalsStyle;
  const baseButtonProps = {
    type: BUTTON_TYPES.MODAL,
    modalElement: decorateComponentWithProps(VideoModal, settings)
  };
  const buttonsMap = {
    [videoButtonsTypes.video]: {
      name: INSERT_PLUGIN_BUTTONS.VIDEO,
      tooltip: t("VideoPlugin_InsertButton_Tooltip"),
      getIcon: () => icon,
      componentData
    },
    [videoButtonsTypes.soundCloud]: {
      name: INSERT_PLUGIN_BUTTONS.SOUND_CLOUD,
      tooltip: t("SoundCloudPlugin_InsertButton_Tooltip"),
      getIcon: () => InsertPluginIcon$1,
      componentData: __spreadProps(__spreadValues({}, DEFAULTS), { type: videoButtonsTypes.soundCloud })
    },
    [videoButtonsTypes.youTube]: {
      name: INSERT_PLUGIN_BUTTONS.YOUTUBE,
      tooltip: t("YouTubePlugin_InsertButton_Tooltip"),
      getIcon: () => YoutubeIcon,
      componentData: __spreadProps(__spreadValues({}, DEFAULTS), { type: videoButtonsTypes.youTube }),
      section: "BlockToolbar_Section_Embed_Anywhere"
    }
  };
  const toolbars = useNewModal ? [TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE] : [TOOLBARS.INSERT_PLUGIN, TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE];
  let videoButtons = exposeButtons.map((buttonType) => __spreadValues(__spreadProps(__spreadValues({}, buttonsMap[buttonType]), {
    toolbars,
    modalStyles,
    modalStylesFn: useNewModal ? ({ buttonRef, toolbarName }) => {
      const isSoundCloud = buttonType === videoButtonsTypes.soundCloud;
      return getBottomToolbarModalStyles(
        buttonRef,
        {
          customStyles: isSoundCloud ? embedModalCustomStyles : videoModalCustomStyles
        },
        toolbarName
      );
    } : void 0
  }), baseButtonProps));
  if (useNewModal) {
    const externalToolbarButtons = exposeButtons.map((buttonType) => {
      const isSoundCloud = buttonType === videoButtonsTypes.soundCloud;
      const styles = isSoundCloud ? DesktopFlyOutModalStyles : videoModalCustomStyles;
      return __spreadValues(__spreadProps(__spreadValues({}, buttonsMap[buttonType]), {
        modalStyles: getModalStyles({
          customStyles: __spreadValues(__spreadValues({}, styles), DesktopOverlayModalStyles),
          fullScreen: isMobile,
          isMobile
        }),
        toolbars: [TOOLBARS.INSERT_PLUGIN]
      }), baseButtonProps);
    });
    videoButtons = [...videoButtons, ...externalToolbarButtons];
  }
  return videoButtons;
};

export { createInsertButtons as default };
//# sourceMappingURL=insert-buttons.js.map
